import { $themeConfig } from "@themeConfig";
import useUserSettings from "@/composables/useUserSettings";

const { getUserSetting, setUserSetting } = useUserSettings();

export default {
    namespaced: true,
    state: {
        layout: {
            isRTL: $themeConfig.layout.isRTL,
            skin: localStorage.getItem("saysimple-skin") || $themeConfig.layout.skin,
            routerTransition: $themeConfig.layout.routerTransition,
            type: $themeConfig.layout.type,
            contentWidth: $themeConfig.layout.contentWidth,
            menu: {
                hidden: $themeConfig.layout.menu.hidden,
            },
            navbar: {
                type: $themeConfig.layout.navbar.type,
                backgroundColor: $themeConfig.layout.navbar.backgroundColor,
            },
            footer: {
                type: $themeConfig.layout.footer.type,
            },
        },
        timeNotation: getUserSetting("timeNotation", 24),
        language: getUserSetting("language", "en"),
        enterToSend: getUserSetting("enterToSend", "1"),
        smartInbox: getUserSetting("smartInboxEnabled", "1"),
    },
    getters: {},
    mutations: {
        UPDATE_USER_SETTINGS(state, userSettings) {
            Object.entries(userSettings).forEach(([name, value]) => {
                state[name] = value;
            });
        },
        UPDATE_LANGUAGE(state, language) {
            // Language value: "nl", "es", "en"
            state.language = language;
            setUserSetting("language", language);
        },
        UPDATE_TIMENOTATION(state, timeNotation) {
            // Timenotation value: 12 or 24
            state.timeNotation = parseInt(timeNotation);
            setUserSetting("timeNotation", timeNotation);
        },
        UPDATE_ENTERTOSEND(state, enterToSend) {
            state.enterToSend = enterToSend;
            setUserSetting("enterToSend", enterToSend);
        },
        UPDATE_SMARTINBOX(state, smartInbox) {
            state.smartInbox = smartInbox;

            localStorage.setItem("smartInboxEnabled", smartInbox);
        },
        TOGGLE_RTL(state) {
            state.layout.isRTL = !state.layout.isRTL;
            document.documentElement.setAttribute("dir", state.layout.isRTL ? "rtl" : "ltr");
        },
        UPDATE_SKIN(state, skin) {
            state.layout.skin = skin;

            // Update value in localStorage
            localStorage.setItem("saysimple-skin", skin);

            // Update DOM for dark-layout
            if (skin === "dark") {
                document.body.classList.add("dark-layout");
            } else if (document.body.className.match("dark-layout")) {
                document.body.classList.remove("dark-layout");
            }
        },
        UPDATE_ROUTER_TRANSITION(state, val) {
            state.layout.routerTransition = val;
        },
        UPDATE_LAYOUT_TYPE(state, val) {
            state.layout.type = val;
        },
        UPDATE_CONTENT_WIDTH(state, val) {
            state.layout.contentWidth = val;
        },
        UPDATE_NAV_MENU_HIDDEN(state, val) {
            state.layout.menu.hidden = val;
        },
        UPDATE_NAVBAR_CONFIG(state, obj) {
            Object.assign(state.layout.navbar, obj);
        },
        UPDATE_FOOTER_CONFIG(state, obj) {
            Object.assign(state.layout.footer, obj);
        },
    },
};
